/**
 *
 * @param rawStr
 * @returns {*}
 */
export const encodeString = rawStr => rawStr.replace(/[\u00A0-\u9999<>\&]/gim, i => '&#' + i.charCodeAt(0) + ';');

const entities = {
    '"': '&quot;',
    '&': '&amp',
    '>': '&gt;',
    '<': '&lt;',
};
const entitiesRegex = new RegExp(Object.keys(entities).join(''), 'gim');
export const encodeHtmlEntities = string => String(string).replace(entitiesRegex, i => entities[i] ?? i);

let markdownConverterInstance;
if (window.showdown && window.showdown.Converter) {
    window.showdown.extension('bootstrap-tables', {
        type: 'output',
        filter: (html) => html.replace(/<table>/g, '<table class="table table-bordered table-striped">')
                .replace(/<thead>/g, '<thead class="bg-primary-500">')
                .replace(/<tbody>/g, '<tbody class="bg-white">')
    });
    window.showdown.extension('bootstrap-blockquotes', {
        type: 'output',
        filter: (html) => html.replace(/<blockquote>/g, '<blockquote class="border-left p-2 rounded border-success bg-gray-50" style="border-width: 2px !important;">'),
    });
    markdownConverterInstance = new window.showdown.Converter({
        simplifiedAutoLink: true,
        strikethrough: true,
        tables: true,
        ghCodeBlocks: true,
        tasklists: true,
        simpleLineBreaks: true
    });
    markdownConverterInstance.addExtension('bootstrap-tables');
    markdownConverterInstance.addExtension('bootstrap-blockquotes');
} else {
    markdownConverterInstance = {
        makeHtml(input) {
            console.error('No converter found - returning source!');
            return input;
        }
    };
}

/**
 * Parser / konwerter formatu Markdown
 * @type {Converter}
 */
export const markdownConverter = markdownConverterInstance;


/**
 * Generuje losowe hasło
 * @param length
 * @param special
 * @return {string}
 */
export const randomPassword = (length, special) => {
    let iteration = 0;
    let password = "";
    let randomNumber;
    if (special === undefined) {
        special = false;
    }
    while (iteration < length) {
        randomNumber = (Math.floor((Math.random() * 100)) % 94) + 33;
        if (!special) {
            if ((randomNumber >= 33) && (randomNumber <= 47)) {
                continue;
            }
            if ((randomNumber >= 58) && (randomNumber <= 64)) {
                continue;
            }
            if ((randomNumber >= 91) && (randomNumber <= 96)) {
                continue;
            }
            if ((randomNumber >= 123) && (randomNumber <= 126)) {
                continue;
            }
        }
        iteration++;
        password += String.fromCharCode(randomNumber);
    }
    return password;
};

/**
 * Generuje losowy ciąg znaków
 * @param length
 * @returns {string}
 */
export const randomString = length => randomPassword(length, false);

/**
 * Zwraca ciąg losowych cyfr
 * @param length
 * @return {string}
 */
export const randomNumberString = length => {
    const numbers = [];
    for (let i = 0; i < length; i++) {
        numbers.push(_.random(0, 9));
    }
    return numbers.join('');
};

/**
 *
 * @param string
 * @returns {string}
 */
export const removeNonASCIICharacters = string => String(string).replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g,"");

/**
 * @param string
 * @returns {string}
 */
export const capitalize = string => {
    return String(string).replace(/(^\w|\s\w)/g, m => m.toUpperCase());
};

/**
 * @param string
 * @returns {string}
 */
export const toUpperCaseFirst = string => {
    string = String(string);
    return string.substring(0, 1).toUpperCase() + string.substring(1);
};

export const toSnakeCase = (string, separator = '_') => {
    return string.split(/(?=[A-Z])/).join(separator).toLowerCase()
}

export const toCamelCase = string => {
    return string
        .replace(/[\W_]+/g, ' ')
        .replace(/\s(.)/g, ($1) => $1.toUpperCase())
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
}

export const toPascalCase = string => {
    return toUpperCaseFirst(toCamelCase(string))
}

/**
 * Zwraca czy string zawiera ciąg następujących po sobie cyfr (malejąco lub rosnąco)
 * @param input
 * @param minSequenceLength
 * @return {boolean}
 */
export const isNumericSequence = (input, minSequenceLength) => {
    input = String(input);
    const length = input.length;
    if (length <= 1) {
        return false;
    }

    if (!minSequenceLength) {
        minSequenceLength = length;
    }

    let sequence = 1;
    let current, previous, isIncrementing = null;
    for (let i = 1; i < length; i++) {
        current = Number(input[i]);
        previous = Number(input[i - 1]);
        if (isIncrementing === null) {
            isIncrementing = previous <= current;
        }
        if (
            (isIncrementing && previous === current - 1) ||
            (!isIncrementing && previous === current + 1)
        ) {
            sequence++;
        } else {
            sequence = 1;
            isIncrementing = null;
        }
        if (sequence >= minSequenceLength) {
            return true;
        }
    }
    return false;
}


/**
 * Zwraca czy string zawiera ciąg powtórzeń tego samego znaku następujących po sobie
 * @param input
 * @param minSequenceLength
 * @return {boolean}
 */
export const isSameCharacterRepeatingSequence = (input, minSequenceLength) => {
    input = String(input);
    length = input.length;
    if (length <= 1) {
        return false;
    }

    if (!minSequenceLength) {
        minSequenceLength = length;
    }
    let sequence = 1;
    for (let i = 1; i < length; i++) {
        if (input[i] === input[i - 1]) {
            sequence++;
        } else {
            sequence = 1;
        }
        if (sequence >= minSequenceLength) {
            return true;
        }
    }
    return false;
}

/**
 * Dodaje fragment do nazwy pliku
 * @param fileName
 * @param append
 * @returns {string}
 */
export const appendFileName = (fileName, append) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const extension = fileName.substring(lastDotIndex + 1);
    return fileName.substring(0, lastDotIndex) + append + '.' + extension;
};

/**
 * @param {string} value
 * @returns {string}
 */
export const slugify = value => String(value)
    .toLowerCase()
    .replace(/\s+/, '-')
    .replace(/[^\w\d-_]/, '');

/**
 * Usuwa HTML z treści
 * @param {String} content
 * @return {String}
 */
export const stripHtml = content => {
    return jQuery('<div>').html(content).text();
};

/**
 * @see https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
 * @param {String} string
 * @return {string}
 */
export function base64Encode(string) {
    // first we use encodeURIComponent to get percent-encoded Unicode,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
}

/**
 * @see https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
 * @param {String} encoded
 * @return {String}
 */
export function base64Decode(encoded) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(encoded).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
